<!-- 组件说明 -->
<template>
  <div class="login-box">
    <div class="login">
      <h3>欢迎登录</h3>
      <el-form
        :rules="loginFormRules"
        class="demo-ruleForm"
        :model="loginForm"
        ref="loginForm"
      >
        <el-form-item prop="account">
          <el-input placeholder="请输入账号" v-model="loginForm.account">
            <i slot="prefix">
              <img :src="require('@/assets/images/icon_number.png')" alt="" />
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            placeholder="请输入你的密码"
            v-model="loginForm.password"
            show-password
          >
            <i slot="prefix">
              <img :src="require('@/assets/images/icon_password.png')" alt="" />
            </i>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="loginBtn" @click="toLogin">登录</div>
      <div class="apply"><span @click="toRegister">申请账号</span></div>
    </div>
    <toast ref="toast"></toast>
  </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
export default {
  components: {},
  data() {
    return {
      type: 2,
      loginForm: {
        account: "",
        password: ""
      },
      loginFormRules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [
          { required: true, message: "请输入你的密码", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    let data = localStorage.getItem("u");
    if (data) {
      let obj = Base64.decode(data);
      let newData = JSON.parse(obj);
      this.loginForm = newData;
    }
  },
  computed: {},
  methods: {
    toLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.$api
          .POST_USERLOGIN({
            password: this.loginForm.password,
            username: this.loginForm.account
          })
          .then(res => {
            if (res.status) {
              // 保存密码
              let newData = JSON.stringify(this.loginForm);
              let obj = Base64.encode(newData);
              localStorage.setItem("u", obj);
              //
              this.$store.commit("LOGIN", res.data);
              this.$router.push({ name: "home" });
              this.$store.dispatch("getCartNum");
            } else if ((res.responseCode = "accountIsError")) {
              //  this.$message.error(res.message);
              this.$refs.toast.info = {
                title: res.message,
                type: "fail"
              };
              this.$refs.toast.isShow();
            }
          });
      });
    },
    toRegister() {
      this.$router.push({ path: "/login", query: { type: 2 } });
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.login-box {
  position: absolute;
  right: 0;
  top: 185px;
  width: 390px;
  height: 344px;
  border-radius: 4px;
  box-shadow: 0 0 10px 10px #f6f6f6;
  border-top: 5px solid #f43737;
  background-color: #ffff;
  .login {
    width: 322px;
    margin: 0 auto;
    h3 {
      font-size: 22px;
      margin: 36px 0 28px 0;
      color: #333333;
    }
    .loginBtn {
      display: block;
      height: 40px;
      cursor: pointer;
      background-color: #fa4b4b;
      border-radius: 2px;
      @include font(16px, #ffffff, center, 400, 40px);
    }
  }
}
.el-form {
  margin-bottom: 32px;
}
>>> .el-input__prefix {
  left: 0px;
  padding: 0 16px;
  i {
    border-right: 1px solid #b2b2b2;
    padding-right: 16px;
  }
}
>>> .el-input--prefix .el-input__inner {
  padding-left: 60px;
  border: 1px solid #dcdfe6 !important;
}
.apply {
  display: block;
  text-align: right;
  padding-right: 8px;
  font-size: 15px;
  color: #fa4b4b;
  margin-top: 20px;
  span {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/components/login.vue